export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;

export const toServerUrl = (pathname) =>
  process.env.REACT_APP_PUBLIC_FILES_API_URL + "/" + pathname;
